import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import TabButton from "../../../../../Components/common/TabButton/TabButton";
import ToggleButton from "../../../../../Components/common/ToggleButton/ToggleButton";
import AgentGroupsForm from "./forms/AgentGroupsForm";
import TextWatermarkForm from "./forms/TextWatermarkForm";
import SubmissionForm from "./forms/SubmissionForm";
import YaraForm from "./forms/YaraForm";
import IOCForm from "./forms/IOCForm";
import AVForm from "./forms/AVForm";
import THunterForm from "./forms/THunterForm";
import ScanForm from "./forms/ScanForm";
import PollingForm from "./forms/PollingForm";
import ResetForm from "./forms/ResetForm";
import GeneralForm from "./forms/GeneralForm";
import Warning from "../../../../../Components/common/Warning/Warning";

import {
  RequestAgentGroups,
  RequestAgentPolicy,
} from "../../../../../store/actions/integrationsActions";

const AgentPoliciesBody = ({ selectedPolicy, selectedHost }) => {
  const dispatch = useDispatch();

  const [active, setActive] = useState("Agent Groups");

  useEffect(() => {
    if (selectedPolicy) {
      dispatch(RequestAgentPolicy({ id: selectedPolicy.id, host: selectedHost }));
      dispatch(RequestAgentGroups(selectedHost));
    }
  }, [dispatch, selectedPolicy, selectedHost]);

  if (!selectedPolicy) return <p className="agent-policies-no-select">Please select a policy.</p>;

  return (
    <div className="agent-policies-body">
      <div className="button-block">
        <TabButton title="Agent Groups" onClick={setActive} active={active} />
        <TabButton title="General" onClick={setActive} active={active} />
        <TabButton title="Text Watermark" onClick={setActive} active={active} />
        <TabButton title="Submission" onClick={setActive} active={active} />
        <TabButton title="YARA" onClick={setActive} active={active} />
        <TabButton title="IOC" onClick={setActive} active={active} />
        <TabButton title="AV" onClick={setActive} active={active} />
        <TabButton title="THunter" onClick={setActive} active={active} />
        <TabButton title="Scan" onClick={setActive} active={active} />
        <TabButton title="Polling" onClick={setActive} active={active} />
        <TabButton title="Reset" onClick={setActive} active={active} />
      </div>

      {active === "Agent Groups" ? (
        <AgentGroupsForm selectedHost={selectedHost} />
      ) : active === "General" ? (
        <GeneralForm key={selectedPolicy.id} selectedHost={selectedHost} />
      ) : active === "Text Watermark" ? (
        <TextWatermarkForm key={selectedPolicy.id} selectedHost={selectedHost} />
      ) : active === "Submission" ? (
        <SubmissionForm key={selectedPolicy.id} selectedHost={selectedHost} />
      ) : active === "YARA" ? (
        <YaraForm key={selectedPolicy.id} selectedHost={selectedHost} />
      ) : active === "IOC" ? (
        <IOCForm key={selectedPolicy.id} selectedHost={selectedHost} />
      ) : active === "AV" ? (
        <AVForm key={selectedPolicy.id} selectedHost={selectedHost} />
      ) : active === "THunter" ? (
        <THunterForm key={selectedPolicy.id} selectedHost={selectedHost} />
      ) : active === "Scan" ? (
        <ScanForm key={selectedPolicy.id} selectedHost={selectedHost} />
      ) : active === "Polling" ? (
        <PollingForm key={selectedPolicy.id} selectedHost={selectedHost} />
      ) : active === "Reset" ? (
        <ResetForm key={selectedPolicy.id} selectedHost={selectedHost} />
      ) : null}
    </div>
  );
};

export default AgentPoliciesBody;
